import api from '@pray/shared/utils/api';
import type { ProbeResponse } from './types';
type Props = { artistId: string; catalogId: string; url: string; headers: Record<string, string>; timeoutMs: number };
export async function postProbeSource({ artistId, catalogId, url, headers, timeoutMs }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  // Unwrap the backend envelope ({ responded_at, object, data }) one level — see getCatalogs.ts.
  const res = await api.executePostRequest<{ data: ProbeResponse }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/source/probe`,
    { url, http_method: 'GET', headers, timeout_ms: timeoutMs });
  return res.data.data;
}
